<div class="ogloginpage">
    <div class="loginwrap">
        <!-- <div class="formside"> -->
            <div class="oglogo">
                <img src="assets/img/logo.svg" alt="">
                <p>
                    {{labelLogin.header1}} <span> {{labelLogin.header2}}</span>
                </p>
            </div>
            <form class="newloginfields" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                    <div class="logincolumn">
                            <div class="formside">
                <div class="formfields">
                    <svg>
                        <use href="assets/img/sprite.svg#newuser"></use>
                    </svg>
                    <input type="text" placeholder="Username" formControlName="email">
                </div>
                <div class="formfields">
                    <svg>
                        <use href="assets/img/sprite.svg#newpassword"></use>
                    </svg>
                    <input type="password" placeholder="Password" formControlName="password" [type]="hide ? 'password': 'text'">
                    <button class="textviewbtns" type="button" (click)="hide=!hide">
                        <svg *ngIf="hide">
                            <use href="assets/img/sprite.svg#closedeye"></use>
                        </svg>
                        <svg *ngIf="!hide">
                            <use href="assets/img/sprite.svg#openedeye"></use>
                        </svg>
                    </button>
                </div>
                <button class="newlogbtn" type="submit">{{labelLogin.signin}}</button>
                            </div>
                        </div>
            </form>
            <div class="newloginfooter">
            <p>
                <!-- <a [routerLink]="" (click)="forgetPassword()">Forgot Your Password?</a> -->
            </p>
            <p class="signupnow">
                {{labelLogin.haveaccount}}
                <!-- <a [routerLink]="">{{labelLogin.signup}}</a> -->
            </p>
            <!-- <div class="deviderline">
                <span>Or</span>
            </div>
            <p>{{labelLogin.socialmedia}}</p>
            <div class="socialmedias">
                <li>
                    <a [routerLink]="['/googleLogin']">
                        <svg>
                            <use href="assets/img/sprite.svg#newgamil"></use>
                        </svg>
                    </a>
                </li>
                <li>
                    <a [routerLink]="">
                        <svg>
                            <use href="assets/img/sprite.svg#newlinkd"></use>
                        </svg>
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/facebookLogin']">
                        <svg>
                            <use href="assets/img/sprite.svg#newfb"></use>
                        </svg>
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/twitterLogin']">
                        <svg>
                            <use href="assets/img/sprite.svg#newtwitter"></use>
                        </svg>
                    </a>
                </li>
            </div> -->
        </div>
        <!-- </div> -->
        <!-- <div class="pictureside">
            <img src="assets/img/Character_bg.png" alt="">
            <div class="textcontents">
                <h3>
                    {{labelLogin.header3}}
                    <span>{{labelLogin.header4}}</span>
                </h3>

                <p>
                    {{labelLogin.content1}}
                </p>
            </div>
        </div> -->
    </div>
</div>